import * as angular from 'angular';
import type { IAugmentedJQuery, IController, IDocumentService } from 'angular';
import type { ThemeService } from './mx-theme.service';
import type { Theme } from './theme.contracts';
import { HandlerCollection } from '../Utils/mx-handler.collection';

export interface ThemeConfig {
	readonly themeId: string;
	readonly isContrastTheme: boolean;
}

export class MxThemeDirectiveCtrl implements IController {
	themeConfig: ThemeConfig;
	id = Math.round(1000000 * Math.random()).toString();
	theme?: Theme;
	changeThemeHandlers = new HandlerCollection<Theme, void>();

	public static readonly $inject = ['$element', '$document', 'mx.app.ThemeService'];

	constructor(
		private readonly $element: IAugmentedJQuery,
		private readonly $document: IDocumentService,
		private themeService: ThemeService
	) {
		this.themeConfig = {
			themeId: '',
			isContrastTheme: false,
		};
	}

	public $onChanges(changes: angular.IOnChangesObject) {
		if (changes.themeConfig?.currentValue) {
			this.applyTheme(changes.themeConfig.currentValue);
		}
	}

	private async applyTheme(themeConfig: ThemeConfig) {
		this.theme = themeConfig.themeId ? await this.themeService.getTheme(themeConfig.themeId, themeConfig.isContrastTheme) : await this.themeService.getCurrentTheme();
		this.themeService.applyCssVariables(this.id, this.theme, this.$document[0] as Document, this.$element[0]);
		this.changeThemeHandlers.execute(this.theme);
	}

	public onThemeChange(scope: angular.IScope, handler: (theme: Theme) => void): void {
		const unsubscribe = this.changeThemeHandlers.add(handler);
		scope.$on('$destroy', () => {
			unsubscribe();
		});
	}
}

export function MxThemeDirective() {
	return {
		restrict: 'A',
		controller: MxThemeDirectiveCtrl,
		bindToController: {
			themeConfig: '<mxTheme',
		},
	};
}
